import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=4e571342&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=4e571342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e571342",
  null
  
)

export default component.exports